import { render, staticRenderFns } from "./FasahCertificate.vue?vue&type=template&id=2ca900a0"
import script from "./FasahCertificate.vue?vue&type=script&lang=js"
export * from "./FasahCertificate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports